import { External_AWS_CDK_Config, FEATURE_ON_OFF } from '@iotv/iotv-v3-types'

const { AWS_DEFAULT_REGION: region, projectCode, stage, accountId } = process.env
const queueUrlPrefix = `https://sqs.${region}.amazonaws.com/${accountId}/${projectCode}-${stage}`
export const lambdaOverrides: External_AWS_CDK_Config['Lamdba'] = {
  [`${projectCode}-${stage}-CalculatedState`]: {
    projectFunctionProps: {
      environment: {
        RETRYENABLED: 'true',
        MAXRETRIESENV: '80',
        RETRY_CUSTOMER_NAMES: '',
        APPLY_SQM: FEATURE_ON_OFF.ON,
        SQM_QUEUE_URL: `${queueUrlPrefix}-sqmQueue`,
        EVENT_QUEUE_URL: `${queueUrlPrefix}-eventCreation`,
        PERSIST_THING_SHADOW_STATES: 'true',
        RULE_ENABLED_ENTITY_TYPES:
          'FlowMeter,Tank,Dam,EffluentPond,EffluentSump,EffluentTank,EffluentTracker,LateralEffluentSpreader,TravellingEffluentSpreader,PivotEffluentSpreader,SpreadingGun',
      },
    },
    additionalSQSQueueGrants: [
      {
        queueName: 'eventQueue',
        queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-eventCreation`,
      },
      {
        queueName: 'sqmQueue',
        queueArn: `arn:aws:sqs:${region}:${accountId}:${projectCode}-${stage}-sqmQueue`,
      },
    ],
  },
}
